var rich_content_viewer_default = {
  "fontElementMap": "FsgBr",
  "wrapper": "ZHdbS",
  "pluginContainerMobile": "THOtB",
  "viewer": "gNUOw",
  "android": "JhEL6",
  "rootedTraversedContent": "_2yXeo",
  "atomic": "X37DB",
  "toolbar": "NvX-I",
  "block": "EEkYD"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
